"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appReleaseDigests = appReleaseDigests;
exports.appManifestDigest = appManifestDigest;
const canonical_json_1 = require("./canonical-json");
/** The digests an App release confirmation binds a release to. */
async function appReleaseDigests(input) {
    const files = Object.fromEntries(Object.entries(input.artifactFiles).map(([path, file]) => [
        path,
        file.sha256,
    ]));
    const [artifactDigest, manifestDigest] = await Promise.all([
        sha256Hex((0, canonical_json_1.canonicalStringify)(files)),
        appManifestDigest(input.manifest),
    ]);
    return { artifactDigest, manifestDigest };
}
/** sha256 over the canonical form of a parsed App manifest. */
function appManifestDigest(manifest) {
    return sha256Hex((0, canonical_json_1.canonicalStringify)(manifest));
}
async function sha256Hex(text) {
    const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    return [...new Uint8Array(digest)]
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');
}
